import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import moment from 'moment';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceStudent } from '../../hooks/useAuthorizedRequestForStudent';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import VidyaUpasna from "../../assets/VidyaUpasna.jpg";
import { GeneratePdf } from '../../components/GeneratePdf';
import { Loader } from '../../components/ModalsCommonFunctions';
import separator_line from "../../assets/separator_line.png";
import { getCurrentTime } from '../../components/CurrentTime';
import { findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const SectionGenerateExamPaper = () => {
    const sectionMasterId = localStorage.getItem("sectionMasterId")
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const isMulti = useRef("N");
    const examType = useRef(null);
    const InstituteAndSectionMasterDetails = useRef(null);
    const [pdfDetails, setPdfDetails] = useState({})
    const [visibleQustionPaper, setVisibleQuestionPaper] = useState(false);
    const [addInstruction, setAddInstruction] = useState(false);
    const [visibleView, setVisibleView] = useState()
    const [visibleResult, setVisibleResult] = useState();
    const [visibleLeaderBoard, setVisibleLeaderBoard] = useState();
    const [questionPaperList, setQuestionPaperList] = useState([]);
    const [examDetails, setExamDetails] = useState([]);
    const [leaderBoardDetails, setLeaderBoardDetails] = useState(null);
    const [selectedExam, setSelectedExam] = useState()
    const [showPassword, setShowPassword] = useState(false);
    const [month, setMonth] = useState(moment().format('YYYY-MM'));
    const [start_date, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [end_date, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

    // const [startIndex, setStartIndex] = useState(null);
    // const [currPage, setCurrPage] = useState(1);
    // const [itemsPerPage, setItemsPerPage] = useState(10);
    // const [displayedData, setDisplayedData] = useState([]);
    // const [totalPages, setTotalPages] = useState(0);
    // const [saveId, setSaveId] = useState(null);

    // const [examNameSort, setExamNameSort] = useState(null);
    // const [examDateSort, setExamDateSort] = useState(null);

    // const [searchValue, setSearchValue] = useState(null);
    // const searchKeys = [
    //     "ExamMaster.exam_name",
    //     "exam_mode",
    //     "startdate_24hrs",
    //     "InstituteGradeMaster.gradeName",
    //     "ExamMaster.uploadPdfExamSubjects.subjectMaster.subjectName",
    //     "ExamMaster.subjectMaster.subjectName",
    //     "ExamMaster.instituteSubjectMaster.subjectName",
    //     "ExamMaster.ExamUploadQuestion.subjectMaster.subjectName",
    //     "ExamMaster.ExamUploadQuestion.instituteSubjectMaster.subjectName",
    //     "ExamMaster.ExamMasterQuestions.subjectMaster.subjectName",
    //     "ExamMaster.ExamMasterQuestions.instituteSubjectMaster.subjectName"
    // ];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    // const togglePasswordVisibility = () => {
    //     setShowPassword(prevState => !prevState);
    // };

    useEffect(() => {
        generatedPdfMasterList()
    }, [month]);

    // useEffect(() => {
    //     if (searchValue === '' && searchValue !== null) {
    //         setCurrPage(1);
    //         getExamMasterList();
    //     }
    // }, [searchValue]);

    // const handleEmptySearch = (e) => {
    //     setSearchValue(e.target.value.trim()); // Only set the trimmed value
    // };

    // const handleSearch = async () => {
    //     if (searchValue !== null) {
    //         // Map searchValue to a numerical value if it matches specific conditions
    //         let processedSearchValue;
    //         if (searchValue === "Offline") processedSearchValue = "1";
    //         else if (searchValue === "Online") processedSearchValue = "2";
    //         else if (searchValue === "Both (Offline + Online)") processedSearchValue = "3";
    //         else processedSearchValue = searchValue;

    //         setQuestionPaperList(
    //             await searchArray("B", `/assigned-exams?section_id=${sectionMasterId}&start_date=${start_date}&end_date=${end_date}`, searchKeys, processedSearchValue, "data")
    //         );
    //     }
    // };

    // useEffect(() => {
    //     if (saveId) {
    //         const pageNumber = findPageNumber(questionPaperList, saveId, itemsPerPage);
    //         setCurrPage(pageNumber);
    //     }
    // }, [saveId])

    // useEffect(() => {
    //     setTotalPages(Math.ceil(questionPaperList.length / itemsPerPage));
    //     const startIndex = (currPage - 1) * itemsPerPage;
    //     let endIndex = startIndex + itemsPerPage;

    //     if (endIndex > questionPaperList.length) {
    //         endIndex = questionPaperList.length;
    //     }
    //     setStartIndex(startIndex);
    //     setDisplayedData(questionPaperList.slice(startIndex, endIndex));
    // }, [questionPaperList, currPage, itemsPerPage]);

    // const handleMonth = (newMonth) => {
    //     setMonth(newMonth ? newMonth.format('YYYY-MM') : '');
    //     setStartDate(newMonth.startOf('month').format('YYYY-MM-DD'));
    //     setEndDate(newMonth.endOf('month').format('YYYY-MM-DD'));
    // };

    const generatedPdfMasterList = async () => {
        // const apiUrl = `/generated-pdf-questions?section_id=${sectionMasterId}&start_date=${start_date}&end_date=${end_date}`;
        const apiUrl = `/generated-pdf-questions?section_id=${sectionMasterId}`;

        try {
            const response = await authorizedAxiosSection.get(apiUrl);
            setQuestionPaperList(response.data.result);
            InstituteAndSectionMasterDetails.current = response.data.InstituteAndSectionMasterDetails;
        } catch (error) {
            setQuestionPaperList([])
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    };


    // const handleExamDetails = (id, multiSubject, exam_type) => {
    //     setLoading(true);
    //     isMulti.current = multiSubject;
    //     examType.current = exam_type;
    //     const apiUrl = (multiSubject === "Y" && exam_type === "M" || exam_type === "U") ? `get-multiple-subject-exam-wise-result?exam_id=${id}` : `/get-exam-wise-result?exam_id=${id}`;
    //     // const apiUrl = `/get-exam-wise-result?exam_id=${id}`;
    //     authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
    //         .then(response => {
    //             setExamDetails(response.data)
    //             setVisibleResult(!visibleResult)
    //         })
    //         .catch(error => {
    //             setExamDetails([])
    //             const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //             Swal.fire({
    //                 text: errorMsg
    //             })
    //         })
    //         .finally(() => {
    //             setLoading(false); // End loading
    //         });
    // }

    // const handleLeaderBoard = (id) => {
    //     setLoading(true);
    //     const apiUrl = `/exams-leaderboard-v2?exam_id=${id}`;
    //     authorizedAxiosStudent && authorizedAxiosStudent.get(apiUrl)
    //         .then(response => {
    //             setLeaderBoardDetails(response.data.leaderboard)
    //         })
    //         .catch(error => {
    //             const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //             console.error('Error fetching data:', errorMsg);
    //         })
    //         .finally(() => {
    //             setLoading(false); // End loading
    //         });
    // }

    // const getSubjectNames = (exam) => {
    //     const subjectName = exam?.is_competitive === 'Y'
    //         ? (
    //             exam?.competitive_exam_type === "A"
    //                 ? exam?.subjectMaster?.subjectName
    //                 : exam?.instituteSubjectMaster?.subjectName
    //         )
    //         : (
    //             exam?.syllabus_structure_type === "A"
    //                 ? exam?.subjectMaster?.subjectName
    //                 : exam?.instituteSubjectMaster?.subjectName
    //         );

    //     // If subjectName is not null, return it
    //     if (subjectName) {
    //         return subjectName;
    //     }

    //     // Check for subject names in ExamUploadQuestion if subjectName is null
    //     const uploadQuestionSubjectNames = [
    //         ...new Set(
    //             exam?.ExamUploadQuestion.map(q =>
    //                 q.subjectMaster?.subjectName || q.instituteSubjectMaster?.subjectName
    //             ).filter(Boolean)
    //         )
    //     ];

    //     // If subject names found in ExamUploadQuestion, return them
    //     if (uploadQuestionSubjectNames.length > 0) {
    //         return uploadQuestionSubjectNames.join(", ");
    //     }

    //     // Check for subject names in ExamMasterQuestions if still null
    //     const masterQuestionSubjectNames = [
    //         ...new Set(
    //             exam?.ExamMasterQuestions.map(q =>
    //                 q.subjectMaster?.subjectName || q.instituteSubjectMaster?.subjectName
    //             ).filter(Boolean)
    //         )
    //     ];

    //     // If subject names found in ExamMasterQuestions, return them
    //     if (masterQuestionSubjectNames.length > 0) {
    //         return masterQuestionSubjectNames.join(", ");
    //     }

    //     // Default fallback message if no subject names found
    //     return "No subjects available";
    // }

    const getSubjectNames = (exam) => {
        // If is_competitive is "N", use paperSubjectName
        if (exam?.is_competitive === "N") {
            const paperSubjectNames = exam?.paperSubjectName || [];

            if (paperSubjectNames.length > 0) {
                const subjectNames = [
                    ...new Set(
                        paperSubjectNames.map(item =>
                            item.subjectMaster?.subjectName || item.instituteSubjectMaster?.subjectName
                        ).filter(Boolean)
                    )
                ];

                if (subjectNames.length > 0) {
                    return subjectNames.join(", ");
                }
            }
        }

        // Default fallback message if no subject names found
        return "No subjects available";
    };

    const handleViewQuestionPaper = async (examTotalMarks, description, gradeName, subjectDetails, id) => {
        console.log("exam total marks: ", examTotalMarks)
        setLoading(true);
        const apiUrl = `get-generated-pdf?id=${id}`;
        try {
            const response = await authorizedAxiosSection.get(apiUrl);
            setPdfDetails({ InstituteAndSectionMasterDetails: InstituteAndSectionMasterDetails.current, examTotalMarks, description, gradeName, subjectDetails, questions: response.data.result })
            setVisibleQuestionPaper(!visibleQustionPaper)
        } catch (err) {
            setPdfDetails({})
            const errorMsg = err?.response?.data?.message || 'Something went wrong!';
            Swal.fire({
                text: errorMsg  
            })
        } finally {
            setLoading(false);
        }
    }


    // useEffect(() => {
    //     if (examNameSort == true || examNameSort == false) {
    //         setExamDateSort(null);
    //     }
    // }, [examNameSort])

    // useEffect(() => {
    //     if (examDateSort == true || examDateSort == false) {
    //         setExamNameSort(null);
    //     }
    // }, [examDateSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Generate Exam Paper</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-folder-open"></i>Generate Exam Paper</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        {/* <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-12 full_wrap">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Month</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={['year', 'month']}
                                                            value={dayjs(month)}
                                                            onChange={handleMonth}
                                                            renderInput={(params) => <TextField {...params} />}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </div>
                                        </div> */}

                                        <div className="d-grid gap-2 mt-2">
                                            <div class="tab-content rounded-bottom custom_table">
                                                {/* <div className='search_btn_row'>
                                                    <input
                                                        className="form-control mr-sm-2"
                                                        type="Search"
                                                        placeholder="Search"
                                                        value={searchValue}
                                                        onChange={handleEmptySearch}
                                                        onKeyDown={(event) => {
                                                            if (event.key === 'Enter') {
                                                                handleSearch();
                                                            }
                                                        }}
                                                    />
                                                    <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                </div> */}
                                                <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                    <table class="table">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" className='sl_no'>Sr. No.</th>
                                                                <th scope="col">
                                                                    Exam Name
                                                                    {/* <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setQuestionPaperList} setCurrPage={setCurrPage} sortingPath={"ExamMaster.exam_name"} /> */}
                                                                </th>
                                                                <th scope="col">Description</th>
                                                                <th scope="col">Class</th>
                                                                <th scope="col">Subject</th>
                                                                <th scope="col">Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                questionPaperList?.length > 0 ?
                                                                    questionPaperList?.map((exam, index) => {
                                                                        const subjectDetails = getSubjectNames({ is_competitive: exam.is_competitive, paperSubjectName: exam.GeneratePdfMasterDetails });
                                                                        return (
                                                                            <tr>
                                                                                <th scope="row" className='sl_no'>{/*startIndex +*/ index + 1}</th>
                                                                                <td>{exam?.generate_pdf_name}</td>
                                                                                <td>{exam?.description}</td>
                                                                                <td>{exam?.InstituteGradeMaster?.gradeName}</td>
                                                                                <td>
                                                                                    {/* {getSubjectNames(subjectDetails)} */}
                                                                                    {subjectDetails}
                                                                                </td>
                                                                                <td>
                                                                                    <div className='btn_group'>
                                                                                        <button className='btn btn-success' onClick={() => { handleViewQuestionPaper(exam.exam_total_marks, exam.description, exam?.InstituteGradeMaster?.gradeName, subjectDetails, exam.id); }}>View </button>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    (<tr>
                                                                        <th colspan={"100%"} style={{ textAlign: 'center' }}>No Exam Paper Available</th>
                                                                    </tr>)
                                                            }
                                                        </tbody>
                                                    </table>
                                                    {/* <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questionPaperList.length} /> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            <CModal
                backdrop="static"
                visible={visibleQustionPaper}
                onClose={() => { setVisibleQuestionPaper(false); setPdfDetails([]); setAddInstruction(false) }}
                aria-labelledby="LiveDemoExampleLabel"
                size="xl"
                className="assign-modal"
            >
                <GeneratePdf id="examPaper" />
                <div className='btn_group'>
                    <button className='print-btn btn btn-info' onClick={() => setAddInstruction(!addInstruction)}>+ Instruction</button>
                </div>

                <div className="row">
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={() => { setVisibleQuestionPaper(false); setPdfDetails([]); setAddInstruction(false) }}
                    ></button>
                </div>


                <div id='examPaper'>
                    <div className="d-grid gap-2 mt-2">
                        <div class="generate_pdf_question_paper_report_block" id="examReportContent">
                            <div class="generate_pdf_question_paper_heading">
                                <div class="generate_pdf_question_paper_logo">
                                    <img src={pdfDetails?.InstituteAndSectionMasterDetails?.instituteMasterDetails?.logoPath} alt="Institute Logo" />
                                </div>
                                <div class="text_center">
                                    <h6>{pdfDetails?.InstituteAndSectionMasterDetails?.instituteMasterDetails?.instituteName}</h6>
                                    <h4>{pdfDetails?.InstituteAndSectionMasterDetails?.sectionName}</h4>
                                </div>
                                <div class="generate_pdf_question_paper_logo">
                                    <img src={pdfDetails?.InstituteAndSectionMasterDetails?.logoPath} alt="Section Logo" />
                                </div>
                            </div>

                            <div class="generate_pdf_question_paper_report_code">
                                <span class="line"></span>
                            </div>

                            <div class="generate_pdf_question_paper_details">
                                <span>Class: {pdfDetails?.gradeName}</span>
                                <span>Subject: {pdfDetails?.subjectDetails}</span>
                                <span>Total Marks: {pdfDetails?.examTotalMarks}</span>
                            </div>

                            <div class="generate_pdf_question_paper_instructions">
                                <h3>Instructions:</h3>
                                <ul>
                                    <li>All questions are mandatory.</li>
                                    <li>Choose the correct option from the given choices.</li>
                                    <li>Each question carries 1 mark.</li>
                                    <li>No negative marking for wrong answers.</li>
                                    {addInstruction && <li>{pdfDetails?.description}</li>}
                                </ul>
                            </div>

                            <ol class="generate_pdf_question_paper_generated_pdf_total_question">
                                {pdfDetails?.questions?.map((question, index) => (
                                    <li key={index} class="generate_pdf_question_paper_question">
                                        <p>{question.question}</p>
                                        <ul>
                                            {['option_a', 'option_b', 'option_c', 'option_d'].map((optionKey, optionIndex) => (
                                                // <li key={optionIndex}>
                                                //     {String.fromCharCode(65 + optionIndex)}. {question[optionKey]}
                                                // </li>

                                                <li key={optionIndex} data-option={String.fromCharCode(65 + optionIndex)}>
                                                    {question[optionKey]}
                                                </li>
                                            ))}
                                        </ul>
                                    </li>
                                ))}
                            </ol>
                        </div>
                    </div>
                </div>



                {/* </div> */}
            </CModal>

        </>
    )
};

export default SectionGenerateExamPaper;